export default __webpack_public_path__ + "static/media/logo-light.f94441b8.png";